export enum RevisionCompareTypes {
    sideBySide = 0,
    unified = 1
}